import { useThemeProps } from '@mui/material';
import blankUser from '../seal.png';
import {VoteMap} from './VoteMap';
import axios from 'axios';

const Helpers = {

    vacantMember: {
      bioGuideId: '0',
      memShortTitle: 'Vacant',
      memImage: {attribution: '<div>Image courtesy of the member</div>', imageUrl: blankUser},
      memName:"Vacant", 
      memNameSub:"",
      vote1:"Missed",
      vote2:"Missed",
      vote3:"Missed",
      vote4:"Missed",
      vote5:"Missed",
      vote6:"Missed",
      vote7:"Missed",
      vote8:'Missed',
      vote9:'Missed',
      vote10: 'Missed',
      memGrade:"Score: 0%"
    },
    repTimKennedyMember: {
      bioGuideId: 'H001038',
      memShortTitle: 'Rep',
      memImage: {attribution: '<div>Image courtesy of the member</div>', imageUrl: 'https://www.congress.gov/img/member/668e9306658443009a697c8c_200.jpg'},
      memName:"Rep. Tim Kennedy", 
      memNameSub:"(D-NY-26)",
      vote1:"Support",
      vote2:"Support",
      vote3:"Support",
      vote4:"Support",
      vote5:"Missed",
      vote6:"Missed",
      vote7:"Support",
      vote8:"Support",
      vote9:"Support",
      vote10:"Support",
      memGrade:"Score: 89%"
    },
    getOneVote(vote){
      let result=0;
      if(vote!='NewMember' && vote!='Present' && vote!="Excused"){
        if (vote=="Support")
        {
          result=1;
        }        
      }
      else
      {
        result=-1;
      }
      return result;
    },
    getGrade: function(memShortTitle, vote1, vote2, vote3, vote4, vote5, vote6, vote7, vote8, vote9, vote10){
      let num=0;
      let den=0;
      let grade = 0;
      let vote=0;
      if (memShortTitle=="Rep"){
        //8, 9, 10 Rep only
        vote=this.getOneVote(vote1);
        if (vote>-1){
          num=num+vote;
          den=den+1
        }
        vote=this.getOneVote(vote2);
        if (vote>-1){
          num=num+vote;
          den=den+1
        }
        vote=this.getOneVote(vote3);
        if (vote>-1){
          num=num+vote;
          den=den+1
        }
        vote=this.getOneVote(vote4);
        if (vote>-1){
          num=num+vote;
          den=den+1
        }
        vote=this.getOneVote(vote5);
        if (vote>-1){
          num=num+vote;
          den=den+1
        }
        vote=this.getOneVote(vote7);
        if (vote>-1){
          num=num+vote;
          den=den+1
        }
        vote=this.getOneVote(vote8);
        if (vote>-1){
          num=num+vote;
          den=den+1
        }
        vote=this.getOneVote(vote9);
        if (vote>-1){
          num=num+vote;
          den=den+1
        }
        vote=this.getOneVote(vote10);
        if (vote>-1){
          num=num+vote;
          den=den+1
        }
      }
      else
      {
        //senator calc
        //6 sen only
        vote=this.getOneVote(vote1);
        if (vote>-1){
          num=num+vote;
          den=den+1
        }
        vote=this.getOneVote(vote2);
        if (vote>-1){
          num=num+vote;
          den=den+1
        }
        vote=this.getOneVote(vote3);
        if (vote>-1){
          num=num+vote;
          den=den+1
        }
        vote=this.getOneVote(vote4);
        if (vote>-1){
          num=num+vote;
          den=den+1
        }
        vote=this.getOneVote(vote5);
        if (vote>-1){
          num=num+vote;
          den=den+1
        }
         vote=this.getOneVote(vote6);
        if (vote>-1){
          num=num+vote;
          den=den+1
        }
        vote=this.getOneVote(vote7);
        if (vote>-1){
          num=num+vote;
          den=den+1
        }
      }
      if (den==0)
      {
          grade='No Vote(s) to Evaluate'
      }
      else
      {
          //grade=(num/den).toFixed(2)*100;
          grade=Math.round(num/den*100)
          grade = 'Score: ' + grade.toString() + '%';
      }
      
      return grade;
     
    }, 
    transformOneVote: function(vote, member, checkChamber){
      let result;
      switch (vote) {
        case "Support":
          result="With IBEW";
          break;
        case "Missed":
          result="Absent";
          break;
        case "Oppose":
          result="Against IBEW";
          break;
        case "NewMember":
          result="Not in Office";
          break;
        default:
          result=vote;
      }
      if (checkChamber==1 && member.memShortTitle=='Rep')
        {result='N/A'}
      if (checkChamber==2 && member.memShortTitle=='Sen')
        {result='N/A'}
            
      return result;

    },
    stripLocalFromAddress: function(address){
      let local;
      local = address.toUpperCase().replace("LU", "");
      local = local.replace("LOCAL", "");
      local = local.replace("UNION", "");
      local = local.replace(" ", "");
      return local;
    }, 
    isAlpha: function(ch){
      return typeof ch === "string" && ch.length === 1
             && (ch >= "a" && ch <= "z" || ch >= "A" && ch <= "Z");
    },
    getMembersFromAddressSearch: function(data, currentMembersOfCongress){

      //use SearchResults
      /*const offices = data.divisions;
      console.log('data', offices);
      const officeRep = offices.find(obj => {
        return obj.name === 'U.S. Representative';
      });
      let divisionId=officeRep.divisionId;*/
      const obj = data.divisions;
      const entries = Object.entries(obj);
      const entry = entries.find(entry => entry[0].toLowerCase().includes("cd:"));
      const [divKey, divVal] = entry;
      let divisionId=divKey;
      
      

      if (divisionId.search("cd:") == -1){
        if (divisionId.search("mt") !==-1) {
          //this is montana and rosendale is congressional dist 2
          divisionId = divisionId + "/cd:2"
        }
        else
        {
          divisionId = divisionId + "/cd:1"
        }
      }
      const stateSearch=divisionId.substring(divisionId.indexOf("state:")+6, divisionId.indexOf("state:")+8);
      const distSearch=divisionId.substring(divisionId.indexOf("cd:")+3, divisionId.indexOf("cd:")+5).trim();
      const repMember = currentMembersOfCongress.filter(mem=>mem.state.trim().toLowerCase()==stateSearch && (mem.district==distSearch || mem.district=="At Large"))[0];
      const senMembers = currentMembersOfCongress.filter(mem=>mem.state.trim().toLowerCase()==stateSearch && mem.short_title.toLowerCase()=="sen");
      
      return [
        {bioGuideId: repMember.id.toUpperCase(), memShortTitle: 'Rep', memImage: "", 
          memName: repMember.short_title + ". " + repMember.first_name + " " + repMember.last_name, memNameSub: "(" + repMember.party.substring(0,1) + "-" +  repMember.state.toUpperCase() + "-" + repMember.district + ")", vote1:"", vote2:"", vote3:"", vote4:"", vote5:"", memGrade:""},
        {bioGuideId: senMembers[0].id.toUpperCase(), memShortTitle: 'Sen', memImage: "", 
        memName: senMembers[0].short_title + ". " + senMembers[0].first_name + " " + senMembers[0].last_name, memNameSub: "(" + senMembers[0].party.substring(0,1) + "-" +  senMembers[0] .state.toUpperCase() + ")", vote1:"", vote2:"", vote3:"", vote4:"", vote5:"", memGrade:""},
        {bioGuideId: senMembers[1].id.toUpperCase(), memShortTitle: 'Sen', memImage: "", 
        memName: senMembers[1].short_title + ". " + senMembers[1].first_name + " " + senMembers[1].last_name, memNameSub: "(" + senMembers[1].party.substring(0,1) + "-" +  senMembers[1] .state.toUpperCase() + ")", vote1:"", vote2:"", vote3:"", vote4:"", vote5:"", memGrade:""}
      ]; 
    },
    getMembersFromDistrictSearch: function(data, currentMembersOfCongress){

      //parse data to get state and distSearches
      const stateSearch=data.substring(0,2).toLowerCase();
      const distSearch=data.substring(3,5).trim();
      
      const repMember = currentMembersOfCongress.filter(mem=>mem.state.trim().toLowerCase()==stateSearch && (mem.district==distSearch || mem.district=="At Large"))[0];
      const senMembers = currentMembersOfCongress.filter(mem=>mem.state.trim().toLowerCase()==stateSearch && mem.short_title.toLowerCase()=="sen");
      
      if (repMember && senMembers){
        return [
          {bioGuideId: repMember.id.toUpperCase(), memShortTitle: 'Rep', memImage: "", 
            memName: repMember.short_title + ". " + repMember.first_name + " " + repMember.last_name, memNameSub: "(" + repMember.party.substring(0,1) + "-" +  repMember.state.toUpperCase() + "-" + repMember.district + ")", vote1:"", vote2:"", vote3:"", vote4:"", vote5:"", memGrade:""},
          {bioGuideId: senMembers[0].id.toUpperCase(), memShortTitle: 'Sen', memImage: "", 
          memName: senMembers[0].short_title + ". " + senMembers[0].first_name + " " + senMembers[0].last_name, memNameSub: "(" + senMembers[0].party.substring(0,1) + "-" +  senMembers[0] .state.toUpperCase() + ")", vote1:"", vote2:"", vote3:"", vote4:"", vote5:"", memGrade:""},
          {bioGuideId: senMembers[1].id.toUpperCase(), memShortTitle: 'Sen', memImage: "", 
          memName: senMembers[1].short_title + ". " + senMembers[1].first_name + " " + senMembers[1].last_name, memNameSub: "(" + senMembers[1].party.substring(0,1) + "-" +  senMembers[1] .state.toUpperCase() + ")", vote1:"", vote2:"", vote3:"", vote4:"", vote5:"", memGrade:""}
        ]; 
      }
      else{
        return []
      }
    },
    getMembersFromLocalUnionSearch: function(data, localCongressionalDistricts, currentMembersOfCongress){
      
      let localUnionMembers = [];
      //start by adding the senators
      const localDistricts = localCongressionalDistricts.filter(lcd=>lcd.Local==data);
      const ldStates = localDistricts.map(ld=>{
        return ld["CongDist"].substring(0,2);
      });
      const uniqueStates = [...new Set(ldStates)].sort() //sort alpha on state abbrev
      let uniqueSens = [];
      let sens = [];

      //some temporary change to not filer on state
      uniqueStates.map(state=>{
        sens=currentMembersOfCongress.filter(cmoc=>cmoc.short_title.toLowerCase()=="sen" && cmoc.state.toLowerCase()==state.toLowerCase());
        sens.map(sen=>
          {
            uniqueSens.push(sen);
          }
        )
      });
      //from the uniqueSens we can convert to object and push to localUnionMembers
      let card = null;
      uniqueSens.map(bioRec=>{
          card={"bioGuideId": bioRec.id,"first_name": bioRec.first_name, "last_name": bioRec.last_name, "party": bioRec.party, "memShortTitle": "Sen", "state": bioRec.state.toUpperCase(), "district": bioRec.district, vote1:"", vote2:"", vote3:"", vote4:"", vote5:"", memGrade:""}
          localUnionMembers.push(card);
        }
      );

      //get the Reps and convert to object and push to localUnionMembers
      let member;
      localDistricts.map(ld=>{
          //get the congressperson
          member=currentMembersOfCongress.filter(cmoc=>cmoc.short_title.toLowerCase()=="rep" && (cmoc.state.toUpperCase() + "-" + cmoc.district.toUpperCase())==ld["CongDist"].toUpperCase().replace("AT-LARGE", "AT LARGE"))[0]
          if (member)
            {
              card={"bioGuideId": member.id,"first_name": member.first_name, "last_name": member.last_name, "party": member.party, "memShortTitle": "Rep", "state": member.state.toUpperCase(), "district": member.district, vote1:"", vote2:"", vote3:"", vote4:"", vote5:"", memGrade:""}
              localUnionMembers.push(card);
            }
        }
      );
      
      /*temporary code to push all moc to use for building reports
      let members=currentMembersOfCongress.filter(cmoc=>cmoc.short_title.toLowerCase()=="rep");
      //now all reps
      members.map(member=>{
        card={"bioGuideId": member.id,"first_name": member.first_name, "last_name": member.last_name, "party": member.party, "memShortTitle": "Rep", "state": member.state.toUpperCase(), "district": member.district, vote1:"", vote2:"", vote3:"", vote4:"", vote5:"", memGrade:""}
        localUnionMembers.push(card);
      })
      end temporary code*/
      
      return localUnionMembers; 
    },
    getMembersFromDropDownList: function(memberId, label, currentMembersOfCongress){

      //this would be bttter to get using memberId (jca);
      //console.log(memberId);
      //console.log(currentMembersOfCongress);
      

      const member=currentMembersOfCongress.filter(mem=>mem.id==memberId)[0];
      //console.log(member);
      //const lName=label.substring(0,label.indexOf(","))
      //for fName, if there are four dashes in the label needs to be the second instande of - because hypenated last name
      /*let fName='';
      let shortTitle ='';
      
      if (label.indexOf("Sen.")>-1){
          //sen version
          if ((label.match(/-/g) || []).length == 2)
          {
            fName=label.substring(label.indexOf(",")+2,label.indexOf("-")-1)
            shortTitle=label.substring(label.indexOf("-")+2,label.indexOf("."))
          }
          else
          {
            //need second instance of "-"
            fName=label.substring(label.indexOf(",")+2,this.getPosition(label, '-', 2)-1)
            shortTitle=label.substring(this.getPosition(label, '-', 2)+2,label.indexOf("."))
          }
      }
      else
      {
        //rep version
        if ((label.match(/-/g) || []).length == 3)
        {
          fName=label.substring(label.indexOf(",")+2,label.indexOf("-")-1)
          shortTitle=label.substring(label.indexOf("-")+2,label.indexOf("."))
        }
        else
        {
          //need second instance of "-"
          fName=label.substring(label.indexOf(",")+2,this.getPosition(label, '-', 2)-1)
          shortTitle=label.substring(this.getPosition(label, '-', 2)+2,label.indexOf("."))
        }
      }
      const subTitle=label.substring(label.indexOf(".")+2,label.length);*/
      let subTitle = member.party.slice(0,1).toUpperCase() + "-" + member.state.toUpperCase() + (member.short_title=="Rep"? "-" + member.district: "");
      
      return [
        {bioGuideId: memberId, memShortTitle: member.short_title, memImage: "", memName: member.short_title + ". " + member.first_name + " " + member.last_name, memNameSub: "(" + subTitle + ")", 
        vote1:"", vote2:"", vote3:"", vote4:"", vote5:"", memGrade:""}
        ]
    },
    updateMembersImageLink: function(members, currentMembersOfCongressDetails){

      //we will need to use tbe bioguide to update the image
      let imgDepiction;
      let memDetail;
      members.map(mem=>{
        imgDepiction={imageUrl: blankUser, attribution: ""};
          memDetail = currentMembersOfCongressDetails.filter(cmocd=>cmocd.bioguideId==mem.bioGuideId)[0];
          if (memDetail){
            if(memDetail.depiction){
              if (memDetail.depiction.imageUrl && memDetail.depiction.imageUrl.length>0){
                imgDepiction=memDetail.depiction;
              }
            }
          }
          mem.memImage = imgDepiction;
      })
      return members;
    }, 
    urlExists: function urlExists(url) {
      var http = new XMLHttpRequest();
      http.open('HEAD', url, false);
      http.send();
      return http.status != 404;
    }, 
    updateMemberVotes: function(members, voteRecords, newMembersOfCongress, voteRecordsAddendum, voteRecordsPn1789, voteRecordsBigBeautifulBill, voteRecordsBigBeautifulHouse2, voteRecordsFlexibility, voteRecordsPrudent){
      members.map(mem=>{
          //use the data to get the vote
          mem.vote1=this.getVote(mem, 'vote1', voteRecords, newMembersOfCongress);
          mem.vote2=this.getVote(mem, 'vote2', voteRecords, newMembersOfCongress);
          mem.vote3=this.getVote(mem, 'vote3', voteRecords, newMembersOfCongress);
          mem.vote4=this.getVote(mem, 'vote4', voteRecords, newMembersOfCongress);
          mem.vote5=this.getVoteFromAddendum(mem, 'vote5', voteRecordsAddendum, newMembersOfCongress);
          if (mem.bioGuideId=="W000831"){
            mem.vote5="NewMember";
          }
          mem.vote6=this.getVoteFromPn1789(mem, 'vote6', voteRecordsPn1789, newMembersOfCongress);
          mem.vote7=this.getVoteFromBigBeautifulBill(mem, 'vote7', voteRecordsBigBeautifulBill, newMembersOfCongress);
          mem.vote8=this.getVoteFromBigBeautifulHouse2(mem, 'vote8', voteRecordsBigBeautifulHouse2, newMembersOfCongress);
          mem.vote9=this.getVoteFromFlexibility(mem, 'vote9', voteRecordsFlexibility, newMembersOfCongress);
          mem.vote10=this.getVoteFromPrudent(mem, 'vote10', voteRecordsPrudent, newMembersOfCongress);
          mem.memGrade=this.getGrade(mem.memShortTitle, mem.vote1, mem.vote2, mem.vote3, mem.vote4, mem.vote5, mem.vote6, mem.vote7, mem.vote8,mem.vote9, mem.vote10);
          //for connelly
          if (mem.bioGuideId=='C001078'){
            mem.vote7='NewMember';
            mem.vote8='NewMember';
            mem.memGrade='Score: 80%'
          }
        }
      )
      return members;
    }, 
    getVote: function(member, voteName, voteRecords, newMembersOfCongress){

      const voteMap = VoteMap; 
      const newMember=newMembersOfCongress.filter(newMem=>newMem.bGuideId==member.bioGuideId)[0];
      
      let shortTitle = member.memShortTitle;
      if (newMember && newMember.ReptoSen119==1){
        shortTitle="Rep";
      }
      
      const rollCall=voteMap.filter(vm=>vm.voteName==voteName && vm.memShortTitle==shortTitle)[0].rollCall;
      const positions=voteRecords.vote_lookups.filter(voteRec=>voteRec.roll_call==rollCall)[0].positions;
      
      const position=positions.filter(pos=>pos.member_id==member.bioGuideId)[0];
      
      let votePosition;
      if (position){
        votePosition=position.vote_position;
      }
      else
      {
        votePosition="No record";
      }
      const voteDesc=this.translatePosition(votePosition, voteName, newMember);
      //translate position to ibew support/oppose label
      return voteDesc;
    },
    getVoteFromAddendum(member, voteName, voteRecordsAddendum, newMembersOfCongress){
      let votePosition;
      const position=voteRecordsAddendum.filter(voteRecAddendum=>voteRecAddendum.member_id==member.bioGuideId)[0];
      if (position){
        votePosition=position.position;
      }
      else
      {
        votePosition="No record";
      }
      const newMember=newMembersOfCongress.filter(newMem=>newMem.bGuideId==member.bioGuideId)[0];
      const voteDesc=this.translatePosition(votePosition,voteName, newMember);
      return voteDesc;
    },
    getVoteFromPn1789(member, voteName, voteRecordsPn1789, newMembersOfCongress){
      let votePosition;
      const position=voteRecordsPn1789.filter(voteRecPn1789=>voteRecPn1789.member_id==member.bioGuideId)[0];
      if (position){
        votePosition=position.position;
      }
      else
      {
        votePosition="No record";
      }
      const newMember=newMembersOfCongress.filter(newMem=>newMem.bGuideId==member.bioGuideId)[0];
      const voteDesc=this.translatePosition(votePosition, voteName, newMember);
      return voteDesc;
    },
    getVoteFromBigBeautifulBill(member, voteName, voteRecordsBigBeautifulBill, newMembersOfCongress){
      let votePosition;
      const position=voteRecordsBigBeautifulBill.filter(voteRecBigBeautifulBill=>voteRecBigBeautifulBill.member_id==member.bioGuideId)[0];
      if (position){
        votePosition=position.position;
      }
      else
      {
        votePosition="No record";
      }
      const newMember=newMembersOfCongress.filter(newMem=>newMem.bGuideId==member.bioGuideId)[0];
      const voteDesc=this.translatePosition(votePosition, voteName, newMember);
      return voteDesc;
    },
    getVoteFromBigBeautifulHouse2(member, voteName, voteRecordsBigBeautifulHouse2, newMembersOfCongress){
      let votePosition;
      const position=voteRecordsBigBeautifulHouse2.filter(voteRecBigBeautifulHouse2=>voteRecBigBeautifulHouse2.member_id==member.bioGuideId)[0];
      if (position){
        votePosition=position.position;
      }
      else
      {
        votePosition="No record";
      }
      const newMember=newMembersOfCongress.filter(newMem=>newMem.bGuideId==member.bioGuideId)[0];
      const voteDesc=this.translatePosition(votePosition, voteName, newMember);
      return voteDesc;
    },
    getVoteFromFlexibility(member, voteName, voteRecordsFlexibility, newMembersOfCongress){
      let votePosition;
      const position=voteRecordsFlexibility.filter(voteRecFlexibility=>voteRecFlexibility.member_id==member.bioGuideId)[0];
      if (position){
        votePosition=position.position;
      }
      else
      {
        votePosition="No record";
      }
      const newMember=newMembersOfCongress.filter(newMem=>newMem.bGuideId==member.bioGuideId)[0];
      const voteDesc=this.translatePosition(votePosition, voteName, false);
      return voteDesc;
    },
    getVoteFromPrudent(member, voteName, voteRecordsPrudent, newMembersOfCongress){
      let votePosition;
      const position=voteRecordsPrudent.filter(voteRecPrudent=>voteRecPrudent.member_id==member.bioGuideId)[0];
      if (position){
        votePosition=position.position;
      }
      else
      {
        votePosition="No record";
      }
      const newMember=newMembersOfCongress.filter(newMem=>newMem.bGuideId==member.bioGuideId)[0];
      const voteDesc=this.translatePosition(votePosition, voteName, false);
      return voteDesc;
    },
    replaceMemberExceptions(members){
      //to replace exceptions for 
      //vacancy
      //tim kennedy

      let idx;
      idx = members.findIndex(mem=>mem.memNameSub==('(R-OH-6)'));
      if (idx!=-1)//match on r-oh-6
      {
          //replace the member with the blank
          members.splice(idx, 1, this.vacantMember);
      }
      idx = members.findIndex(mem=>mem.memNameSub==('(D-NY-26)'));
      if (idx!=-1)//match on r-oh-6
      {
          //replace the member with the blank
          members.splice(idx, 1, this.repTimKennedyMember);
      }
      return members;
    },
    translatePosition: function(position, voteName, newMember){

      
      let voteDesc;
      //translate the position
      if(position=="Yes"){
        voteDesc = "Support";
      }
      else if (position=="No"){
        voteDesc = "Oppose";
      }
      else if (position=="No record"){
        voteDesc="Missed";
      }
      else if (position=="Not Voting"){
        voteDesc="Missed";
      }
      else{
        voteDesc=position;
      }

      //flip the position for vote7
      if (voteName=="vote7" || voteName=="vote8" || voteName=="vote9" || voteName=="vote10")
      {
        if (voteDesc=="Support")
        {
          voteDesc="Oppose";
        }
        else if (voteDesc=="Oppose"){
          voteDesc="Support";
        }
      }

      if(newMember && voteDesc=="Missed"){
        if (newMember.NewMember119==1){
          if(newMember.ReptoSen119==1){
            if(voteName=="vote6"){
              voteDesc="NewMember";
            }
          } 
          else
          {
            voteDesc="NewMember";
          }
        }
        else if(newMember.NewMember118==1){
          if (voteName=="vote4"){
            if(newMember.AbsentFiscal==1){
              voteDesc="NewMember";
            }
          } 
          else{
            if (voteName!="vote5" && voteName!="vote6"){
              voteDesc="NewMember";
            }
          }
        }
      }
      return voteDesc;
    },
    getPosition: function(string, subString, index) {
      return string.split(subString, index).join(subString).length;
    }
}

    

export default Helpers;